import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login({ setIsLoggedIn }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [port, setPort] = useState(() => {
    // Get saved port from localStorage or default to 3001
    const savedPort = localStorage.getItem('apiPort');
    return savedPort ? parseInt(savedPort) : 3001;
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Save port to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('apiPort', port);
  }, [port]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`https://pdf-service.planex.cloud/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) throw new Error('Login failed');
      
      const { token } = await response.json();
      localStorage.setItem('token', token);
      setIsLoggedIn(true);
      navigate('/');
    } catch (err) {
      setError('Invalid credentials', err);
    }
  };

  return (
    <div className="login-container">
      <h2 className="title">Px PDF Service</h2>
      <form className="login-form" onSubmit={handleSubmit}>
        {/* <div className="form-group">
          <label>API Port</label>
          <input
            type="number"
            min="1024"
            max="65535"
            required
            className="form-input"
            value={port}
            onChange={(e) => setPort(parseInt(e.target.value) || 3000)}
          />
        </div> */}

        <div className="form-group">
          <label>Username</label>
          <input
            required
            className="form-input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Password</label>
          <input
            required
            type="password"
            className="form-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        {error && <p className="error">{error}</p>}

        <button type="submit" className="button button-primary" style={{ marginTop: '1rem'}}>
          Sign in
        </button>
      </form>
    </div>
  );
}